<template>
  <v-text-field
    :id="id"
    v-model="password"
    :type="showPassword ? 'text' : 'password'"
    :color="hasError ? 'danger' : 'primary'"
    :error="hasError"
    class="bg-white"
    variant="outlined"
    placeholder="入力してください"
    maxlength="16"
    :hide-details="true"
    @input="onPasswordInput"
  >
    <template #append-inner>
      <v-icon
        tabindex="-1"
        :icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        color="grey-darken-1"
        @click="showPassword = !showPassword"
      />
    </template>
  </v-text-field>
</template>

<script setup lang="ts">
const password = defineModel<string>();

defineProps<{
  id: string;
  hasError?: boolean;
}>();

const showPassword = ref(false);

const {
  filterHalfWidthCharacter,
} = useInputFilter();

/**
 * パスワード入力時の処理
 */
const onPasswordInput = (e: Event) => {
  filterHalfWidthCharacter(e, password, 16);
};
</script>
